import { Component, Vue } from 'vue-property-decorator';

// Components
import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';
import Loading from '@/components/Global/Loading.vue';

// Services
import Claims from '@/services/Claims';
import * as Sentry from '@sentry/browser';

@Component({
     name: 'Claims',
     components: {
          Sidebar,
          Loading,
     },
})
export default class ClaimsMixin extends Vue {
     private loading: boolean;
     private claims: any;
     private error: boolean;

     constructor() {
          super();

          this.loading = true;
          this.claims = [];
          this.error = false;
     }

     private async created() {
          try {
               const getClaims = await Claims.getClaims();

               if (getClaims.data) {
                    this.claims = getClaims.data;
                    this.claims.map(o => {
                         o.claim_status = Claims.getClaimStatus(o);

                         return o;
                    });
               }
          } catch (e) {
               this.error = e;
               Sentry.captureException(e);
          } finally {
               this.loading = false;
          }
     }
}
